import React from "react";
import PropTypes from "prop-types";
import { Container } from "reactstrap";
import "../assets/styles/BottomBar.scss";

class BottomBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      display: true,
    };
  }
  componentDidMount() {
    document.addEventListener("scroll", this.trackScrolling);
  }

  componentWillUnmount() {
    document.removeEventListener("scroll", this.trackScrolling);
  }

  setDisplay(flag) {
    if (this.state.display !== flag) {
      this.setState({ display: flag });
    }
  }

  trackScrolling = () => {
    const bottomEl = this.props.bottomEl;
    const el = bottomEl ? bottomEl : document.getElementById("footer");
    if (this.isBottom(el)) {
      this.setDisplay(false);
    } else {
      this.setDisplay(true);
    }
  };

  isBottom(el) {
    return el.getBoundingClientRect().top <= window.innerHeight;
  }

  render() {
    const { children } = this.props;
    const { display } = this.state;
    const displayClass = display ? "show" : "hide";
    return (
      <div className={"bottom-bar " + displayClass}>
        <Container>{children}</Container>
      </div>
    );
  }
}

BottomBar.propTypes = {
  children: PropTypes.node.isRequired,
  bottomEl: PropTypes.object,
};

BottomBar.defaultProps = {
  bottomEl: null,
};

export default BottomBar;
